<template>
<div>
  <!-- HEADER TITULO -->
  <div class="titulo-contenido">
      <h1>
          <span class="negrita">NOTIFICACIONES POR EDICTOS</span>
      </h1>

  </div>
  <!--  -->
  <div class="container">
      <div class="row">
        <div class="col-md-12">
          <boton-atras :nombre_ruta="'Home'"/>
        </div>
        <div class="contenido-texto mt-4 col-md-12">
          <p>De conformidad con la reforma al artículo 140 del Código Fiscal de la Federación publicada en el Diario Oficial de la Federación el 5 de enero de 2004, las notificaciones por edictos se harán mediante publicaciones durante tres días consecutivos en el Diario Oficial de la Federación, por un día en un diario de mayor circulación y durante quince días consecutivos en la página electrónica que al efecto establezcan las autoridades fiscales, y contendrán un resumen de los actos que se notifican.</p>
          <p>Se tendrá como fecha de notificación la de la última publicación en el Diario Oficial de la Federación o en la página electrónica citada, según sea el caso.</p>
          <p>En cumplimiento a la disposición legal citada, se notifica lo siguiente:</p>
        </div>
        <div class="container"> <!-- contenedor_padre-->
            <div class="col-md-12">
                 <notificacionesTable :documentos="data" />
            </div>
        </div>

      </div>
      <span v-html="fecha_actualizacion"></span>
  </div>
</div>
</template>
<script>
// import cardsMenu from '../../../components/cardsMenu.vue';
import mapFun from "@/common/map-fn-types.js";
import mixin from "@/mixins/mixin.js";
import Notificaciones from "@/services/notificaciones/notificacionesPorEdictos.js"
import botonAtras from '../button-atras';
import DateFormat from "@/mixins/dateFormatMixin.js";
import notificacionesTable from '../../components/notificacionesTable.vue'
const notificaciones_Service = new Notificaciones();
export default {
name: 'notificacionesPorEstrados',
components: {botonAtras, notificacionesTable},
data(){
  return {
    data: [],
    fecha_actualizacion:''
  };
},
  async created(){
    this.getNotificacionesEdictos();
  },
  mixins: [mixin, DateFormat],
  methods:{
    async getNotificacionesEdictos(){
        try {
            const response = await notificaciones_Service.getNotificacionesPorEdictos(mapFun.notificacionesPorEdictos);
            this.data = response.reverse();
            
            this.mapeoFecha();
            // console.log('response.data',this.data);
        } catch (error) {
            console.log('error v', error.message);
        }
    },
        async mapeoFecha(){
      let fecha_texto = this.data[0].fecha_actualizacion;
      console.log(fecha_texto);

      let day = fecha_texto.slice(0, 2); // Primeros 2 caracteres -> "26"
      let month = fecha_texto.slice(3, 5); // Caracteres 4-5 -> "11"
      let year = fecha_texto.slice(6, 10); // Caracteres 7-10 -> "2024"

      let fecha_formateada = `${year}-${month}-${day}`; // Formato YYYY-MM-DD
      this.fecha_actualizacion = fecha_formateada;

      console.log('fecha TEXT -->', fecha_texto);
      console.log('fecha FORMATEADA -->', fecha_formateada);
      this.fecha_actualizacion = this.DateFormatText(fecha_formateada);
      
    }
  },
watch: {
},
}
</script>
<style scoped>
.contenido-texto p{text-align: justify;}
</style>
